<template lang="html">

  <div :class="{'error': error}">
    <font-awesome-icon class="faTab" :icon="icon"/>
    <small class="ml-2" style="display:inline-block">
    <span><strong>{{ heading }}</strong></span>
    <span>&nbsp;{{ subheading }}</span>
    </small>        
  </div>

</template>

<script lang="js">
  export default  {
    name: 'tab-item',
    props: {
      icon: {
        type: String,
        required: true
      },
      heading: {
        type: String,
        required: true
      },
      subheading: {
        type: String,
        required: true
      },
      error: {
        type: Boolean
      }
    },
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {
    }
}
</script>

<style scoped lang="scss">
.faTab {
  margin-top: -1.175rem;
  font-size: 20px;
}
span {
  display: block;
}

.error {
  color: #dc3545;
}
</style>
